import mapTypes from "./map.types";

export const setCenterOfMap = (location) => ({
  type: mapTypes.SET_CENTEROFMAP,
  payload: location,
});

export const fetchCenterOfMapAddressStart = () => ({
  type: mapTypes.FETCH_CENTEROFMAPADDRESS_START,
});

export const fetchCenterOfMapAddressSuccess = (data) => ({
  type: mapTypes.FETCH_CENTEROFMAPADDRESS_SUCCESS,
  payload: data,
});

export const toggleMapOverlayLeftShow = (bool) => ({
  type: mapTypes.TOGGLE_MAPLEFTOVERLAY_SHOW,
  payload: bool,
});

export const setMapLevel = (level) => ({
  type: mapTypes.SET_MAP_LEVEL,
  payload: level,
});

export const increaseMapLevel = () => ({
  type: mapTypes.INCREASE_MAP_LEVEL,
});

export const decreaseMapLevel = () => ({
  type: mapTypes.DECREASE_MAP_LEVEL,
});

export const fetchSuggestionsStart = () => ({
  type: mapTypes.FETCH_ADDRESSSUGGESTIONS_START,
});

export const fetchSuggestionsSuccess = (data) => ({
  type: mapTypes.FETCH_ADDRESSSUGGESTIONS_SUCCESS,
  payload: data,
});
export const setSuggestionsShow = (bool) => ({
  type: mapTypes.SET_SUGGESTIONS_SHOW,
  payload: bool,
});
export const setBottomWhiteLong = (bool) => ({
  type: mapTypes.SET_BOTTOMWHITE_LONG,
  payload: bool,
});
export const setGoLevel4 = (bool) => ({
  type: mapTypes.SET_GOLEVEL_4,
  payload: bool,
});

export const setSourceLocationJustSet = (bool) => ({
  type: mapTypes.SET_SOURCELOCATION_JUSTSET,
  payload: bool,
});

// async
let fetchCenterOfMapAddressAsync_counter = 0;

export const fetchCenterOfMapAddressAsync = (socket) => (
  dispatch,
  getState
) => {
  dispatch(fetchCenterOfMapAddressStart());

  let type = "s";
  if (Number(getState().map.level) === 1) type = "d";
  const obj = {
    type,
    lat: getState().map.centerOfMap.lat,
    long: getState().map.centerOfMap.lng,
  };

  socket.emit("get_address_by_point", obj);
  //   debugger;

  if (fetchCenterOfMapAddressAsync_counter++ !== 0) return;
  socket.on("response_get_address_by_point", (data) => {
    // console.log(data);
    // alert("hi");
    dispatch(fetchCenterOfMapAddressSuccess(data));
    // debugger;
    // if (data.type == "s") STATE.startLocation = data;
    // else STATE.endLocation = data;

    // handle_caption();
    // console.log(STATE);
  });
};

let fetchSuggestionsSuccess_counter = 0;

export const fetchSuggestionsAsync = (socket, content) => (
  dispatch,
  getState
) => {
  dispatch(fetchSuggestionsStart());

  socket.emit("get_address_by_address", {
    content,
    lat: getState().map.centerOfMap.lat,
    long: getState().map.centerOfMap.lng,
  });
  if (fetchSuggestionsSuccess_counter++ !== 0) return;
  socket.on("response_address_by_address", (data) => {
    // alert("sadf");
    // const y = getState().map.suggestions;
    // const x = getState().map.suggestions.length;
    // if (getState().map.suggestions.length < 3) {
    //   debugger;
    //   return;
    // }
    // debugger;
    dispatch(fetchSuggestionsSuccess(data));
    // debugger;
    // updateSuggestAddress(data);
  });
};
